import { useDeleteResource__ALPHA } from '@cube3/state/src/redux/components/Hooks/useDeleteResource';
import { useResourceList__ALPHA } from '@cube3/state/src/redux/components/Hooks/useResourceList';
import { RequestStatuses } from '@cube3/state/src/redux/ducks/request-status/state';
import { useCallback, useMemo } from 'react';

const config = {
  cacheInvalidator: (r) => [r]
};

export const useDeleteMetadataValues = (projectId, formValues = {}) => {
  const { resources: retrievedValues } = useResourceList__ALPHA({
    resourceId: projectId,
    resourceType: 'project',
    edgeType: 'metadata-value',
    edgeLabel: 'metadata-values',
    strategy: 'fetch-on-mount'
  });

  const [deleteResource, deleteResourceStatus] =
    useDeleteResource__ALPHA(config);

  const toDelete = useMemo(() => {
    if (!retrievedValues) return [];
    return Object.keys(formValues)
      .filter((key) => !!formValues[key] || formValues[key] === 0)
      .map((k) => {
        const field_id = k.replace('field_', '');
        return {
          type: 'metadata-value' as const,
          id: retrievedValues.find((val) => val.field_id === field_id)?.id
        };
      });
  }, [retrievedValues, formValues]);

  const onDelete = useCallback(() => {
    if (toDelete.length) {
      deleteResource(toDelete);
    }
  }, [toDelete, deleteResource]);

  return [onDelete, deleteResourceStatus] as [() => void, RequestStatuses];
};
